export default __webpack_public_path__ + "static/media/icon_7.8f24acda.png";